module.exports = __webpack_public_path__ + "media/components/assets/icons/back_btn_sharp-0c4fd5dcc026bba50e87348634ffb4fd.svg";